import { getWorkspaceConfigValue } from "containers/WorkspaceConfig/WorkspaceConfig.selectors";
import { useSelector } from "react-redux";

export const useWorkspaceConfigValue = (variable: string) => {
    return useSelector((state) => getWorkspaceConfigValue(state, variable));
};
